module.exports = __webpack_public_path__ + "static/angel-guest-with-flower-dd8581a40f8dcb1cbccd66b89b2bddad.jpg";